import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { Navbar, Nav, NavDropdown } from "react-bootstrap";
import { MenuItem } from "react-bootstrap";
import Logo from "./new_logo.svg";
import { logout, myself } from "redux/authenticate/actions";
import "./component_style.css";

const Account = ({ name, logout }) => (
  <NavDropdown title={name} id="dropdown-account">
    <MenuItem onClick={logout}>Выйти</MenuItem>
  </NavDropdown>
);

const Header = ({ user, logout }) => (
  <Navbar>
    <Navbar.Header>
      <Navbar.Brand>
        <Link to={"/"}>
          <img src={Logo} alt="alt" />
        </Link>
        <span className="logo-text">Header Bidding</span>
      </Navbar.Brand>
    </Navbar.Header>
    {user.name && (
      <Nav pullRight>{user && <Account {...user} logout={logout} />}</Nav>
    )}
  </Navbar>
);

class Container extends Component {
  componentDidMount() {
    this.props.myself();
  }
  render() {
    const { user, logout } = this.props;
    return <Header logout={logout} user={user} />;
  }
}

export default connect(({ user: { data } }) => ({ user: data }), {
  logout,
  myself
})(Container);
